import type { ConfirmOptions } from '@hooks/useDialog'
import { t } from '@utils/i18n-to-migrate/useTranslations'

export const CONFIRM_DIALOGS = {
  'archive-property': {
    title: t('confirm.archiveProperty.title'),
    description: t('confirm.archiveProperty.description'),
    actionLabel: t('confirm.archiveProperty.actionLabel'),
    cancelLabel: t('general.cancel'),
  },
  'archive-property-blocked': {
    title: t('confirm.archivePropertyBlocked.title'),
    description: t('confirm.archivePropertyBlocked.description'),
    cancelLabel: t('general.close'),
  },
  'delete-item': {
    title: t('confirm.deleteItem.title'),
    description: t('confirm.deleteItem.description'),
    actionLabel: t('confirm.deleteItem.actionLabel'),
    cancelLabel: t('general.cancel'),
  },
  'remove-co-owner': {
    title: t('confirm.removeCoOwner.title'),
    description: t('confirm.removeCoOwner.description'),
    actionLabel: t('confirm.removeCoOwner.actionLabel'),
    cancelLabel: t('general.cancel'),
  },
  'remove-contact-person': {
    title: t('confirm.contactPersonModal.title'),
    description: t('confirm.contactPersonModal.description'),
    actionLabel: t('confirm.contactPersonModal.actionLabel'),
    cancelLabel: t('general.cancel'),
  },
  'close-register-form': {
    title: t('confirm.closeRegisterForm.title'),
    description: t('confirm.closeRegisterForm.description'),
    actionLabel: t('confirm.closeRegisterForm.actionLabel'),
    cancelLabel: t('general.cancel'),
  },
  'delete-file': {
    title: t('file-upload.confirm.deleteFile.title'),
    description: t('file-upload.confirm.deleteFile.description'),
    actionLabel: t('file-upload.confirm.deleteFile.actionLabel'),
    cancelLabel: t('general.cancel'),
  },
  'delete-power-of-attorney': {
    title: t('confirm.deletePowerOfAttorney.title'),
    description: t('confirm.deletePowerOfAttorney.description'),
    actionLabel: t('confirm.deletePowerOfAttorney.actionLabel'),
    cancelLabel: t('general.cancel'),
  },
  'cancel-file-upload': {
    title: t('file-upload.confirm.cancelFileUpload.title'),
    description: t('file-upload.confirm.cancelFileUpload.description'),
    actionLabel: t('file-upload.confirm.cancelFileUpload.actionLabel'),
    cancelLabel: t('file-upload.confirm.cancelFileUpload.cancelLabel'),
  },
  'cancel-contractor-registration': {
    title: t('confirm.cancelContractorRegistration.title'),
    description: t('confirm.cancelContractorRegistration.description'),
    actionLabel: t('confirm.cancelContractorRegistration.actionLabel'),
    cancelLabel: t('general.close'),
  },
  'cancel-salesagreement-registration': {
    title: t('timberbuyer-salesagreements-register.cancelDialog.title'),
    description: t('timberbuyer-salesagreements-register.cancelDialog.description'),
    actionLabel: t('timberbuyer-salesagreements-register.cancelDialog.confirmCancel'),
    cancelLabel: t('timberbuyer-salesagreements-register.cancelDialog.continueEditing'),
  },
  'cancel-salesagreement-edit': {
    title: t('timberbuyer-salesagreements-edit.cancelDialog.title'),
    description: t('timberbuyer-salesagreements-edit.cancelDialog.description'),
    actionLabel: t('timberbuyer-salesagreements-edit.cancelDialog.confirmCancel'),
    cancelLabel: t('timberbuyer-salesagreements-edit.cancelDialog.continueEditing'),
  },
  'cancel-priceperiod-edit': {
    title: t('timberbuyer-salesagreements-priceperiods.edit.cancelDialog.title'),
    description: t('timberbuyer-salesagreements-priceperiods.edit.cancelDialog.description'),
    actionLabel: t('timberbuyer-salesagreements-priceperiods.edit.cancelDialog.confirmCancel'),
    cancelLabel: t('timberbuyer-salesagreements-priceperiods.edit.cancelDialog.continueEditing'),
  },
  'cancel-copy-price-period': {
    title: t('timberbuyer-salesagreements-priceperiods.copyActions.cancelDialog.title'),
    description: t('timberbuyer-salesagreements-priceperiods.copyActions.cancelDialog.description'),
    actionLabel: t(
      'timberbuyer-salesagreements-priceperiods.copyActions.cancelDialog.confirmCancel',
    ),
    cancelLabel: t(
      'timberbuyer-salesagreements-priceperiods.copyActions.cancelDialog.continueCreating',
    ),
  },
  'cancel-create-empty-price-period': {
    title: t('timberbuyer-salesagreements-priceperiods.createEmpty.cancelDialog.title'),
    description: t('timberbuyer-salesagreements-priceperiods.createEmpty.cancelDialog.description'),
    actionLabel: t(
      'timberbuyer-salesagreements-priceperiods.createEmpty.cancelDialog.confirmCancel',
    ),
    cancelLabel: t(
      'timberbuyer-salesagreements-priceperiods.createEmpty.cancelDialog.continueEditing',
    ),
  },
  'cancel-shareholder-registration': {
    title: t('confirm.cancelShareholderRegistration.title'),
    description: t('confirm.cancelShareholderRegistration.description'),
    actionLabel: t('confirm.cancelShareholderRegistration.actionLabel'),
    cancelLabel: t('general.close'),
  },
  'cancel-partner-add': {
    title: t('confirm.cancelPartnerAdd.title'),
    description: t('confirm.cancelPartnerAdd.description'),
    actionLabel: t('confirm.cancelPartnerAdd.actionLabel'),
    cancelLabel: t('confirm.cancelPartnerAdd.cancelLabel'),
  },
  'cancel-partner-remove': {
    title: t('confirm.cancelPartnerRemove.title'),
    description: t('confirm.cancelPartnerRemove.description'),
    actionLabel: t('confirm.cancelPartnerRemove.actionLabel'),
    cancelLabel: t('confirm.cancelPartnerRemove.cancelLabel'),
  },
  'cancel-partner-remove-choice': {
    title: t('confirm.cancelPartnerRemoveChoice.title'),
    description: t('confirm.cancelPartnerRemoveChoice.description'),
    actionLabel: t('confirm.cancelPartnerRemoveChoice.actionLabel'),
    cancelLabel: t('confirm.cancelPartnerRemoveChoice.cancelLabel'),
  },
  'confirm-partner-remove': {
    title: t('confirm.confirmPartnerRemove.title'),
    description: t('confirm.confirmPartnerRemove.description'),
    actionLabel: t('confirm.confirmPartnerRemove.actionLabel'),
    cancelLabel: t('confirm.confirmPartnerRemove.cancelLabel'),
  },
  'cancel-timberbuyer-registration': {
    title: t('confirm.cancelTimberbuyerRegistration.title'),
    description: t('confirm.cancelTimberbuyerRegistration.description'),
    actionLabel: t('confirm.cancelTimberbuyerRegistration.actionLabel'),
    cancelLabel: t('general.close'),
  },
  'cancel-timberbuyer-edit': {
    title: t('timberbuyer.edit.cancelDialog.title'),
    description: t('timberbuyer.edit.cancelDialog.description'),
    actionLabel: t('timberbuyer.edit.cancelDialog.confirmCancel'),
    cancelLabel: t('timberbuyer.edit.cancelDialog.continueEditing'),
  },
  'cancel-contractor-edit': {
    title: t('contractor.edit.cancelDialog.title'),
    description: t('contractor.edit.cancelDialog.description'),
    actionLabel: t('contractor.edit.cancelDialog.confirmCancel'),
    cancelLabel: t('contractor.edit.cancelDialog.continueEditing'),
  },
  'cancel-edit-shareownership': {
    title: t('share-ownership.closeTransferForm.title'),
    description: t('share-ownership.closeTransferForm.description'),
    actionLabel: t('share-ownership.closeTransferForm.actionLabel'),
    cancelLabel: t('share-ownership.closeTransferForm.cancelLabel'),
  },
  'cancel-end-shareownership': {
    title: t('share-ownership.closeEndShareownershipForm.title'),
    description: t('share-ownership.closeEndShareownershipForm.description'),
    actionLabel: t('share-ownership.closeEndShareownershipForm.actionLabel'),
    cancelLabel: t('share-ownership.closeEndShareownershipForm.cancelLabel'),
  },
  'remove-property-verification': {
    title: t('forestowner-search-overview-property.propertyDocumentation.removeProperty.title'),
    actionLabel: t(
      'forestowner-search-overview-property.propertyDocumentation.removeProperty.actionLabel',
    ),
    cancelLabel: t(
      'forestowner-search-overview-property.propertyDocumentation.removeProperty.cancelLabel',
    ),
  },
  'cancel-employee-add': {
    title: t('contractor.addEmployee.cancelDialog.title'),
    description: t('contractor.addEmployee.cancelDialog.description'),
    actionLabel: t('contractor.addEmployee.cancelDialog.confirmCancel'),
    cancelLabel: t('contractor.addEmployee.cancelDialog.continueEditing'),
  },
  'cancel-employee-edit': {
    title: t('contractor.editEmployee.cancelDialog.title'),
    description: t('contractor.editEmployee.cancelDialog.description'),
    actionLabel: t('contractor.editEmployee.cancelDialog.confirmCancel'),
    cancelLabel: t('contractor.editEmployee.cancelDialog.continueEditing'),
  },
  'cancel-forest-crew-add': {
    title: t('contractor.addForestCrew.cancelDialog.title'),
    description: t('contractor.addForestCrew.cancelDialog.description'),
    actionLabel: t('contractor.addForestCrew.cancelDialog.confirmCancel'),
    cancelLabel: t('contractor.addForestCrew.cancelDialog.continueEditing'),
  },
  'cancel-forest-crew-edit': {
    title: t('contractor.forestCrew.edit.cancelDialog.title'),
    description: t('contractor.forestCrew.edit.cancelDialog.description'),
    actionLabel: t('contractor.forestCrew.edit.cancelDialog.confirmCancel'),
    cancelLabel: t('contractor.forestCrew.edit.cancelDialog.continueEditing'),
  },
} as const satisfies Record<string, ConfirmOptions>

// Automatically inferred type from the record keys
export type ConfirmDialogType = keyof typeof CONFIRM_DIALOGS

/**
 * Get confirm dialog configuration by type
 */
export const getConfirmDialog = (type: ConfirmDialogType): ConfirmOptions => {
  return CONFIRM_DIALOGS[type]
}

/**
 * Get conditional confirm dialog based on condition
 */
export const getConditionalConfirmDialog = (
  condition: boolean,
  trueType: ConfirmDialogType,
  falseType: ConfirmDialogType,
): ConfirmOptions => {
  return condition ? getConfirmDialog(trueType) : getConfirmDialog(falseType)
}
